// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__W_p-W","productName":"Table_productName__w_hvr"};